import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export const QuizResult = ({ result, onRestart, onShopAll }) => (
  <div className="fade-up" data-testid="quiz-result">
    <div className="grid grid-cols-12 gap-6 lg:gap-12 mb-12">
      <div className="col-span-12 lg:col-span-7">
        <div className="micro-label text-[#1a1814]/60 mb-3 inline-flex items-center gap-2">
          <CheckCircle2 className="w-3 h-3" /> Your capsule
        </div>
        <h2 className="font-display text-4xl lg:text-5xl text-[#1a1814] leading-tight">
          Three pieces, drafted to your fit.
        </h2>
        <p className="text-[#1a1814]/70 italic mt-4" data-testid="quiz-style-note">{result.style_note}</p>
      </div>
      <div className="col-span-12 lg:col-span-5 self-end flex flex-wrap gap-3 lg:justify-end">
        <button
          type="button"
          onClick={onRestart}
          className="micro-label border border-[#1a1814] px-6 py-3 hover:bg-[#1a1814]/5"
          data-testid="quiz-restart-btn"
        >
          Take it again
        </button>
        <button
          type="button"
          onClick={onShopAll}
          className="micro-label bg-[#1a1814] text-[#f0e9e1] px-6 py-3 hover:bg-[#1a1814]/85"
          data-testid="quiz-shop-all-btn"
        >
          Shop the full collection
        </button>
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-10">
      {result.recommendations.map((p, i) => (
        <Link
          to={`/shop/${p.slug}`}
          key={p.id}
          className="group fade-up"
          style={{ animationDelay: `${i * 0.1}s` }}
          data-testid={`quiz-recommendation-${p.id}`}
        >
          <div className="relative overflow-hidden bg-[#efe6db] aspect-[3/4]">
            <img
              src={p.image}
              alt={p.name}
              style={{ objectPosition: p.image_position || "center" }}
              className="img-zoom w-full h-full object-cover"
            />
            <div className="absolute top-4 left-4 micro-label text-[#f0e9e1] bg-[#1a1814]/85 px-2 py-1 text-[9px]">
              Pick {String(i + 1).padStart(2, "0")}
            </div>
          </div>
          <div className="mt-5 flex justify-between items-start">
            <div>
              <h3 className="font-serif text-xl leading-tight">{p.name}</h3>
              <p className="text-xs text-[#1a1814]/60 mt-1 italic">{p.tagline}</p>
            </div>
            <div className="font-serif text-lg whitespace-nowrap ml-4">£{p.price.toFixed(0)}</div>
          </div>
        </Link>
      ))}
    </div>
  </div>
);
